import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@design-system/box';
export const Title = ({ customPadding, title }) => (_jsx(Box, Object.assign({ as: "h1", font: { s: 'h2-semibold', m: 'h1-semibold' }, width: "100%" }, customPadding, { children: title })));
//# sourceMappingURL=Title.js.map